import { render, staticRenderFns } from "./passingStyle_pie.vue?vue&type=template&id=09b35b2c&scoped=true"
import script from "./passingStyle_pie.vue?vue&type=script&lang=js"
export * from "./passingStyle_pie.vue?vue&type=script&lang=js"
import style0 from "./passingStyle_pie.vue?vue&type=style&index=0&id=09b35b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b35b2c",
  null
  
)

export default component.exports